export const firmInitiativesStatusUILabel = {
    'open': 'Open',
    'withdrawn': 'Withdrawn',
    'closed': 'Closed',
    'applied': 'Applied',
}
